import { Form, Slider } from "antd";
import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { getNumberLocale } from "src/utility";

const Range: FC<{ valuesMap: Map<string | number, any[]>; filter: any }> = ({ valuesMap, filter }) => {
  const { t } = useTranslation();
  const numericKeys = Array.from(valuesMap.keys()).map((k) => (typeof k === "string" ? Number(k) : k));
  const filteredKeys = numericKeys.filter((k) => !isNaN(k));
  const min = Math.min(...filteredKeys, Infinity);
  const max = Math.max(...filteredKeys, 0);
  const [value, setValue] = useState([min, max]);
  const firstJourney = valuesMap.values().next().value?.[0];
  const deps = Object.fromEntries(
    ((filter.dependencies ?? []) as { key: string; path: (string | number)[] }[]).map((dep) => [
      dep.key,
      firstJourney ? dep.path.reduce((o: any, k) => o?.[k], firstJourney) : undefined,
    ])
  );
  const minValueLabel = filter?.labelTransform ? filter.labelTransform(value?.[0], deps) : value?.[0]?.toLocaleString(getNumberLocale());
  const maxValueLabel = filter?.labelTransform ? filter.labelTransform(value?.[1], deps) : value?.[1]?.toLocaleString(getNumberLocale());

  return (
    <div className="flex flex-col">
      <span className="text-xs font-semibold text-font-default">
        {t("Filters.selectARangePrefix")}
        <span className="text-background-primary font-bold">
          {minValueLabel}:{maxValueLabel}
        </span>
        {t("Filters.selectARangeSuffix")}
      </span>
      <Form.Item name={filter.key} className="m-0!">
        <Slider
          range
          min={min}
          max={max}
          value={value}
          onChange={(value) => {
            setValue(value);
          }}
          classNames={{
            track: "bg-background-primary!",
            handle: "whitespace-nowrap!",
          }}
          tooltip={undefined}
        />
      </Form.Item>
    </div>
  );
};

export default Range;
